var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStarCelebration = function SvgStarCelebration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96.54,
    height: 112.58
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-35.722 1.03)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.243,
    cy: 3.243,
    r: 3.243,
    fill: "#ff4b4e",
    stroke: "#1f2a3b",
    strokeWidth: 2,
    "data-name": "Ellipse 205",
    transform: "translate(38.227 73.664)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.243,
    cy: 3.243,
    r: 3.243,
    fill: "#ffca54",
    stroke: "#1f2a3b",
    strokeWidth: 2,
    "data-name": "Ellipse 206",
    transform: "translate(53.175 36.206)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.243,
    cy: 3.243,
    r: 3.243,
    fill: "#00cdb3",
    stroke: "#1f2a3b",
    strokeWidth: 2,
    "data-name": "Ellipse 207",
    transform: "translate(97.453 28.428)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#57bae5",
    stroke: "#1f2a3b",
    strokeWidth: 2,
    "data-name": "Group 4285",
    transform: "translate(65.722 12.137)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.243,
    cy: 3.243,
    r: 3.243,
    "data-name": "Ellipse 208",
    transform: "translate(59.053 61.84)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.243,
    cy: 3.243,
    r: 3.243,
    "data-name": "Ellipse 209"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ffcd61",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m124.619 54.38-27.373-3.994-12.242-24.9a3.065 3.065 0 0 0-5.5 0l-12.242 24.9-27.373 3.994a3.084 3.084 0 0 0-1.7 5.254l19.81 19.385-4.679 27.373a3.073 3.073 0 0 0 4.451 3.247l24.483-12.924c26.637 14.061 24.841 13.277 25.91 13.277a3.078 3.078 0 0 0 3.024-3.6l-4.676-27.372 19.807-19.385a3.086 3.086 0 0 0-1.7-5.255",
    "data-name": "Path 19016"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f99830",
    stroke: "#1f2a3b",
    strokeWidth: 2,
    d: "M52.793 30.573c-1.863-.356-5.094-2.685-3.994-8.954.4-2.289-.093-2.476-2.786-3.088-2.631-.6-6.607-1.5-6.893-7.064a1.768 1.768 0 1 1 3.53-.182c.142 2.768 1.446 3.185 4.145 3.8 2.424.55 6.48 1.472 5.485 7.146-.755 4.3 1.156 4.867 1.176 4.87a1.768 1.768 0 1 1-.663 3.473Z",
    "data-name": "Path 19017"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.295,
    cy: 2.295,
    r: 2.295,
    fill: "#57bae5",
    stroke: "#1f2a3b",
    strokeWidth: 2,
    "data-name": "Ellipse 210",
    transform: "translate(40.25 32.604)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.295,
    cy: 2.295,
    r: 2.295,
    fill: "#00cdb3",
    stroke: "#1f2a3b",
    strokeWidth: 2,
    "data-name": "Ellipse 211",
    transform: "translate(115.759 79.182)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.295,
    cy: 2.295,
    r: 2.295,
    fill: "#ffca54",
    stroke: "#1f2a3b",
    strokeWidth: 2,
    "data-name": "Ellipse 212",
    transform: "translate(42.293 93.336)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ff4b4e",
    stroke: "#1f2a3b",
    strokeWidth: 2,
    "data-name": "Group 4286"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.694 31.96a1.768 1.768 0 0 1-.036-2.5l2.456-2.527a1.768 1.768 0 0 1 2.535 2.464l-2.456 2.527a1.768 1.768 0 0 1-2.499.036Z",
    "data-name": "Path 19018"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.906 30.989-3.266-1.321a1.768 1.768 0 1 1 1.325-3.278l3.266 1.321a1.768 1.768 0 0 1-1.326 3.278Z",
    "data-name": "Path 19019"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#00cdb3",
    stroke: "#1f2a3b",
    strokeWidth: 2,
    d: "m48.136 88.792-3.266-1.321a1.768 1.768 0 0 1 1.325-3.278l3.266 1.321a1.768 1.768 0 0 1-1.325 3.278Z",
    "data-name": "Path 19020"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#57bae5",
    stroke: "#1f2a3b",
    strokeWidth: 2,
    d: "m122.319 94.742-3.266-1.321a1.768 1.768 0 1 1 1.325-3.278l3.266 1.32a1.768 1.768 0 0 1-1.325 3.278Z",
    "data-name": "Path 19021"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#faae5c",
    "data-name": "Group 4287"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#1f2a3b",
    strokeWidth: 2,
    d: "M101.453 1.46a1.768 1.768 0 0 0-3.482.615c.482 2.729-.695 3.428-3.187 4.631-2.239 1.08-5.985 2.887-3.743 8.194 1.705 4.036-.054 5.01-.054 5.01-.495.328-2.059.909-1.391 2.5 1.154 2.75 8.312-.342 4.7-8.886-.9-2.14-.465-2.434 2.023-3.634 2.431-1.172 6.103-2.943 5.134-8.43Z",
    "data-name": "Path 19022"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1f2a3b",
    strokeWidth: 2,
    d: "M128.258 27.088a1.768 1.768 0 0 0-2.461.439 12.589 12.589 0 0 0-1.766 6.007c-.382 3.355-.525 4.612-4.032 4.387-3.862-.247-6.748.581-8.579 2.458-2.255 2.313-2.175 5.5-.049 5.539 1.768.03 1.888-1.854 1.888-1.854s.365-3 6.515-2.615c9.684.617 6.589-8.553 8.923-11.9a1.767 1.767 0 0 0-.439-2.461Z",
    "data-name": "Path 19023"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.043 47.144 85.315 26.33l-.265-.536a3.083 3.083 0 0 0-5.524 0l-12.291 24.9 4.161-.739a5.349 5.349 0 0 0 3.647-2.811",
    "data-name": "Path 19024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.02 105.213 4.18-24.376a5.785 5.785 0 0 0-1.261-4.728L44.827 58.455a3.08 3.08 0 0 1 .63-4.883l-5.558.807a3.08 3.08 0 0 0-1.707 5.254l19.887 19.385-4.695 27.373a3.083 3.083 0 0 0 4.469 3.247l3.118-1.639a3.078 3.078 0 0 1-.951-2.786",
    "data-name": "Path 19025"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1f2a3b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m124.619 54.38-27.373-3.994-12.242-24.9a3.065 3.065 0 0 0-5.5 0l-12.242 24.9-27.373 3.994a3.084 3.084 0 0 0-1.7 5.254l19.81 19.385-4.679 27.373a3.073 3.073 0 0 0 4.451 3.247l24.483-12.924c26.637 14.061 24.841 13.277 25.91 13.277a3.078 3.078 0 0 0 3.024-3.6l-4.676-27.372 19.807-19.385a3.086 3.086 0 0 0-1.7-5.255",
    "data-name": "Path 19212"
  }))));
};
export default SvgStarCelebration;